import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { authHeader } from "../../helpers";
import api from "../../constants/api";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Pagination from "@material-ui/lab/Pagination";
import { Button } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
// import Dialog from "material-ui/Dialog";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import BreadCrumbNav from "../BreadCrumbNav";
import { getUser,getUserSort,getComparator,stableSort,getFilterOptions} from '../../helpers';
import { postApi } from '../../helpers/http';
import Autocomplete from '@material-ui/lab/Autocomplete';
import swal from 'sweetalert';

import "./Setting.css";

const OS_INDEX = 0;
const USER_INDEX = 1;
const SECTION_INDEX = 2;
const DEPT_INDEX = 3;
const kTables = [
   "os_master",
   "user_master",
   "section_master",
   "department_master",
];
const kInputName = ["OS", "ユーザー名", "部", "課"];
const headCells = [
   { id: "name", minWidth: 170, disablePadding: false, label: "ユーザー名" },
   { id: "section_name", minWidth: 190, disablePadding: false, label: "部" },
   { id: "department_name", minWidth: 190, disablePadding: false, label: "課" },
];
const kCanEditRole = [false, false, true, true];
const kCanSortRole = [false, true, true, true];

function TabPanel(props) {
   const { children, value, index } = props;

   return (
      <div className="panel-container" role="tabpanel" hidden={value !== index}
         id={`scrollable-auto-tabpanel-${index}`}
         aria-labelledby={`scrollable-auto-tab-${index}`}
      >
         {value === index && (
            <Box p={3}>
               <Typography>{children}</Typography>
            </Box>
         )}
      </div>
   );
}

TabPanel.propTypes = {
   children: PropTypes.node,
   index: PropTypes.any.isRequired,
   value: PropTypes.any.isRequired,
};

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
   const result = Array.from(list);
   const [removed] = result.splice(startIndex, 1);
   result.splice(endIndex, 0, removed);
   return result;
};

const grid = 0;

const getItemStyle = (isDragging, draggableStyle, disabled) => {
   const cursor = isDragging ? "grabbing" : "grab";
   return {
      // some basic styles to make the items look a bit nicer
      userSelect: disabled ? null : "none",
      padding: grid * 2,
      margin: `0 0 ${grid}px 0`,

      // change background colour if dragging
      background: isDragging ? "lightblue" : "white",

      cursor: disabled ? "default" : cursor,

      // styles we need to apply on draggables
      ...draggableStyle,
   };
};

const getListStyle = (isDraggingOver) => ({
   background: isDraggingOver ? "lightgrey" : "white",
   padding: grid,
   width: 250,
});

class Setting extends Component {
   constructor(props) {
      const userSort = getUserSort();
      super(props);
      this.state = {
         confirmDialog: false,
         selectedData: {},
         offset: 0,
         limit: 100,
         date: null,
         tabValue: 0,
         data: [],
         i_num: -1,
         inputName: "",
         selectedDeptId: -1,
         selectedSectionId: -1,
         order: "asc",
         orderBy: "name",
         isDnD: true,
         detailData: [],
         detaiLDataUser: [], 
         sections: [],
         departments: [],
         isFetching: true,
         totalRows: 0,
         isChangedPosition: false,
         section_name: null,
         section_id : null,
         name01: null,
         name02 : null,
         name03 : null,
         name04 : null,
         user_id : null,
         department_name: null,
         department_id : null,
         isNewItemVisible: false,
         departmentOptions: [],
         sectionOptions: [],
         isCanceled: false,
      };
      this.isComposing = false;
      this.nameInputRef = React.createRef();
   }

   async getSettings(params) {
      const data = {
         process_type: "getMasterList",
         table_name: params.table_name,
      };

      this.setState({ isFetching: true });
      try {
         const json = await postApi(data);
         console.log(json.data);
         const rawData = json.data.detailData;
         const sortedData = stableSort(json.data.detailData, getComparator(this.state.order, this.state.orderBy));
         this.setState({
            detailData: params.table_name == "user_master" ? rawData : sortedData,
            sections: json.data.sections,
            departments: json.data.departments,
            totalRows: json.data.detailData.length,
            isFetching: false,
            detaiLDataUser: rawData,
            firstLoad: true,

         });

      } catch (error) {
            this.setState({ detailData: [], totalRows: 0, isFetching: false });
            console.error("Error:", error);
      };
   }

   componentDidMount() {
      let tabValue = OS_INDEX;
      const query = new URLSearchParams(this.props.location.search);
      const settingId = query.get("id");
      if (settingId) {
         tabValue = parseInt(settingId, 10);
      }
      this.setState({ tabValue }, () => {
         const params = {
            offset: this.state.offset * this.state.limit,
            limit: this.state.limit,
            table_name: kTables[tabValue],
         };
         this.getSettings(params);
      });
   }

   handleClickDownloadCSV = (filteredItems) => {
      let csvHeaderTitles = [];
      let filename = "";
      const date = new Date();
      const options = {
          timeZone: "Asia/Tokyo",
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
      };
      
      const formattedDate = new Intl.DateTimeFormat('ja-JP', options).format(date).replace(/\D/g, '');
      const csvRows = ["検索条件："];
      switch(this.state.tabValue) {
         case 0: 
            csvHeaderTitles = ["OS"];
            filename = `OSマスタ編集_${formattedDate}.csv`;
            if (this.state.name01 === null) {
              csvRows.push("　OS: すべて");
            } else if (this.state.name01 === "") {
              csvRows.push("　OS: 空白");
            } else {
              csvRows.push("　OS: " + this.state.name01);
            };
         break;
    
         case 1: 
            csvHeaderTitles = ["ユーザー名", "部", "課"];
            filename = `ユーザーマスタ編集_${formattedDate}.csv`;
            if (this.state.name02 === null) {
              csvRows.push("　ユーザー名: すべて");
            } else if (this.state.name02 === "") {
              csvRows.push("　ユーザー名: 空白");
            } else {
              csvRows.push("　ユーザー名: " + this.state.name02);
            };
      
            if (this.state.section_name === null) {
              csvRows.push("　部: すべて");
            } else if (this.state.section_name === "") {
              csvRows.push("　部: 空白");
            } else {
              csvRows.push("　部: " + this.state.section_name);
            };
      
            if (this.state.department_name === null) {
              csvRows.push("　課: すべて");
            } else if (this.state.department_name === "") {
              csvRows.push("　課: 空白");
            } else {
              csvRows.push("　課: " + this.state.department_name);
            };
         break;
    
         case 2: 
            csvHeaderTitles = ["部"];
            filename = `部マスタ編集_${formattedDate}.csv`;
            if (this.state.name03 === null) {
              csvRows.push("　部: すべて");
            } else if (this.state.name03 === "") {
              csvRows.push("　部: 空白");
            } else {
              csvRows.push("　部: " + this.state.name03);
            };
         break;
    
         case 3: 
            csvHeaderTitles = ["課名"];
            filename = `課マスタ編集_${formattedDate}.csv`;

            if (this.state.name04 === null) {
              csvRows.push("　課: すべて");
            } else if (this.state.name04 === "") {
              csvRows.push("　課: 空白");
            } else {
              csvRows.push("　課: " + this.state.name04);
            };
         break;
    
        default:
          return; 
      }

      csvRows.push([csvHeaderTitles.join(',')]);
      filteredItems.forEach(item => {
         let row = [];
         switch(this.state.tabValue) {
            case 0:
               row = [item.name];
            break;
            case 1:
               row = [
                  item.name,
                  item.section_name,
                  item.department_name,
               ];
            break;
            case 2:
               row = [item.name];
            break;
            case 3:
               row = [item.name];
            break;
         }
         if (item.name !== "") {
            csvRows.push(row.map(v => `"${v.toString().replace(/"/g, '""')}"`).join(','));
         };
      });
    
      const csvData = csvRows.join('\n');
      const BOM = '\uFEFF'; // BOM for UTF-8
      const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

   changePagination = (event, newPage) => {
      const newOffset = newPage - 1;
      this.setState({
         offset: newOffset
      });
   };

   handleComposition = (e) => {
      if (e.type === "compositionstart") {
         this.isComposing = true;
         return;
      }
  
      if (e.type === "compositionend") {
         this.isComposing = false;
         this.setState({
           inputName: e.target.value
         });
         return;
      }
   };

   handleChange = (e) => {
      if (this.isComposing) return;
  
      this.setState({
        inputName: e.target.value
      });
   };
   
   render() {
      const user = getUser();
      const { totalRows, detailData, offset, limit, order, orderBy, tabValue } = this.state;
      const isFetching = this.state.isFetching;

      const isShowPagination =
         !isFetching &&
         totalRows > 0 &&
         totalRows > this.state.limit &&
         !this.state.isChangedPosition;

      const handleTabChange = (event, newValue) => {
         // const { getSettings } = this.props;
         const offset = this.state.tabValue === newValue ? this.state.offset : 0;
         const params = {
            offset: offset * this.state.limit,
            limit: this.state.limit,
            table_name: kTables[newValue],
         };
         this.getSettings(params);
         this.setState({
            isChangedPosition: false,
            tabValue: newValue,
            offset,
            i_num: -1,
            inputName: "",
            selectedDeptId: -1,
            selectedSectionId: -1,
            user_id: null,
            name01: null,
            name02: null,
            name03: null,
            name04: null,
            department_name: null,
            department_id: null,
            section_name: null,
            section_id: null,
            isNewItemVisible: false,
            order: "asc",
            orderBy: "name",
         });
      };
      // 新規作成
      const handleClickNew = () => {
         this.setState(prevState => {
            const filteredData = prevState.detailData.filter(item => item.i_num !== -1);
            const newItem = {
               i_num: -1,
               name: "",
               section_id: -1,
               department_id: -1,
               //   user_id : -1 ,
               //   id : -1 ,
               section_name: "",
               department_name: "",
               isNew: true 
            };

            return {
               detailData: [newItem, ...filteredData], 
               i_num: -1, 
               inputName: "",
               selectedSectionId: -1,
               selectedDeptId: -1,
               isNewItemVisible: true,
               isCanceled: false,
               name01: null,
               name02: null,
               name03: null,
               name04: null,
               department_name: null,
               department_id: null,
               section_name: null,
               section_id: null,
               offset: 0 
            };
         },
         () => {
            //フォーカス設定
             if (this.nameInputRef.current) {
                 this.nameInputRef.current.focus();
             }
         });
      };
  
      const apiFetchData = async (event, data) => {
         
         try {
            const json = await postApi(data);
            handleTabChange(event, this.state.tabValue);
            return json;

         } catch (error) {
            console.error("Error:", error);
            throw error;
         }
         
      };

      const handleClickAdd = (event) => {
         const { name } = event.currentTarget;
         const i_num = Number(name);
         let data = {};

         const trimmedName = this.state.inputName.trim();

         if (trimmedName.replace(/\s+/g, "") === "") {
            swal({
               title: "設定エラー！",
               text: kInputName[this.state.tabValue] + "を入力してください。",
               icon: "warning",
               button: "はい"
            });
            return;
         }
         
         swal({
            title: "登録しますか？",
            icon: "warning",
            buttons: ["いいえ", "はい"],
            dangerMode: true,
         })
         .then((confirm) => {
            if (!confirm) return;
            if (i_num === -1) {
               data = {
                  process_type: "insertMaster",
                  table_name: kTables[this.state.tabValue],
                  name: trimmedName,
               };
               if (this.state.tabValue === 1) {
                  // ユーザー
                  data["section_id"] = this.state.selectedSectionId;
                  data["department_id"] = this.state.selectedDeptId;
               }
            } else {
               const Index = _.findIndex(this.state.detailData, function (o) {
                  return o.i_num === i_num;
               });
               data = {
                  process_type: "updateMaster",
                  table_name: kTables[this.state.tabValue],
                  name: trimmedName,
                  i_num: this.state.detailData[Index].i_num,
               };
               if (this.state.tabValue === 1) {
                  data["section_id"] = this.state.selectedSectionId;
                  data["department_id"] = this.state.selectedDeptId;
               }
            }

         apiFetchData(event, data)
         .then((res) => {
            if (res?.statusCode === 200) {
               swal({
                  title: "登録しました。",
                  icon: "success",
                  button: "はい"
               });
            } else {
               swal({
                  title: "設定エラー！",
                  text: kInputName[this.state.tabValue] + "が存在しました。他の" + kInputName[this.state.tabValue] + "を設定してください。",
                  icon: "warning",
                  button: "はい"
               });
            }
         })
         .catch((err) => {
            console.error(err);
            swal({
               title: "エラー！",
               text: "通信エラーが発生しました。",
               icon: "error",
               button: "はい"
            });
      });
         });
      };

      const handleClickAddSection = (event) => {
         if (this.state.tabValue !== SECTION_INDEX) {
            swal({
               title: "選択エラー",
               text: "部選択エラー",
               icon: "warning",
               button: "はい"
            });
            return;
         }
         const { name } = event.currentTarget;
         const i_num = Number(name);
         let data = {};
         const trimmedName = this.state.inputName.trim();

         if (trimmedName.replace(/\s+/g, "") === "") {
            swal({
               title: "設定エラー！",
               text: kInputName[this.state.tabValue] + "を入力してください。",
               icon: "warning",
               button: "はい"
            });
            return;
         }
         swal({
            title: "登録しますか？",
            icon: "warning",
            buttons: ["いいえ", "はい"],
            dangerMode: true,
         })
         .then((confirm) => {
            if (!confirm) return;
            if (i_num === -1) {
               data = {
                  process_type: "insertMaster",
                  table_name: kTables[this.state.tabValue],
                  name: trimmedName,
               };
            } else {
               const Index = _.findIndex(this.state.detailData, function (o) {
                  return o.i_num === i_num;
               });
               data = {
                  process_type: "updateMaster",
                  table_name: kTables[this.state.tabValue],
                  name: trimmedName,
                  i_num: this.state.detailData[Index].i_num,
               };
            }
            apiFetchData(event, data)
            .then((res) => {
               if (res?.statusCode === 200) {
               swal({
                  title: "登録しました。",
                  icon: "success",
                  button: "はい"
               });
            } else {
               swal({
                  title: "設定エラー！",
                  text: kInputName[this.state.tabValue] + "が存在しました。他の" + kInputName[this.state.tabValue] + "を設定してください。",
                  icon: "warning",
                  button: "はい"
               });
            }
            })
            .catch((err) => {
               console.error(err);
               swal({
                  title: "エラー！",
                  text: "通信エラーが発生しました。",
                  icon: "error",
                  button: "はい"
               });
            });
         });
      };

      const handleClickAddDept = (event) => {
         if (this.state.tabValue !== DEPT_INDEX) {
            window.alert("部選択エラー");
            return;
         }
         const { name } = event.currentTarget;
         const i_num = Number(name);
         let data = {};
         const trimmedName = this.state.inputName.trim()

         if (trimmedName.replace(/\s+/g, "") === "") {
            swal({
               title: "設定エラー！",
               text: kInputName[this.state.tabValue] + "を入力してください。",
               icon: "warning",
               button: "はい"
            });
            return;
         }
         swal({
            title: "登録しますか？",
            icon: "warning",
            buttons: ["いいえ", "はい"],
            dangerMode: true,
         })
         .then((confirm) => {
            if (!confirm) return;

            if (i_num === -1) {
               data = {
                  process_type: "insertMaster",
                  table_name: kTables[this.state.tabValue],
                  name: trimmedName,
                  section_id: this.state.selectedSectionId,
               };
            } else {
               const Index = _.findIndex(this.state.detailData, function (o) {
                  return o.i_num === i_num;
               });
               data = {
                  process_type: "updateMaster",
                  table_name: kTables[this.state.tabValue],
                  name: trimmedName,
                  i_num: this.state.detailData[Index].i_num,
                  section_id: this.state.selectedSectionId,
               };
            }
            apiFetchData(event, data)
            .then((res) => {
               if (res?.statusCode === 200) {
               swal({
                  title: "登録しました。",
                  icon: "success",
                  button: "はい"
               });
            } else {
               swal({
                  title: "設定エラー！",
                  text: kInputName[this.state.tabValue] + "が存在しました。他の" + kInputName[this.state.tabValue] + "を設定してください。",
                  icon: "warning",
                  button: "はい"
               });
            }
            })
            .catch((err) => {
               console.error(err);
               swal({
                  title: "エラー！",
                  text: "通信エラーが発生しました。",
                  icon: "error",
                  button: "はい"
               });
            });
         });
      };

      // OSマスタ・部署編集モードに変更
      const handleClickEdit = (event, text) => {
         const { name } = event.currentTarget;
         const i_num = Number(name);
         this.setState(prevState => {
            const updatedData = prevState.detailData.map(item => ({
              ...item,
              i_num: item.i_num === i_num ? i_num : item.i_num
            }));
            // const filteredData = updatedData.filter(item => item.i_num !== -1 && !item.isNew);
            return {
              detailData: updatedData,
              i_num: i_num,
              inputName: text,
              isNewItemVisible: false,
              isCanceled: false
            };
          },
         () => {
             //フォーカス設定
             if (this.nameInputRef.current) {
                 this.nameInputRef.current.focus();
             }
         });
         this.setState({ i_num: Number(name) });
         this.setState({ inputName: text });
         console.log("handleClickEdit");

      };

      const handleClickCancel = (event, text) => {
         const { name } = event.currentTarget;
         const i_num = Number(name);

         if (i_num === -1) {
            this.setState(prevState => {
               const updatedData = prevState.detailData.filter(item => item.i_num !== -1)
               return {
                 detailData: updatedData,
                 isNewItemVisible: false
               };
             });

         };

         this.setState({ isCanceled: true });
      };

      // 部選択
      const getSelectedSectionId = (sections, section_id) => {
         const sectionFound = sections.find(
            (section) => section.i_num === section_id
         );
         // console.log(department_id, sectionFound);
         return sectionFound ? sectionFound.i_num : -1;
      };

      // 課選択
      const getSelectedDeptId = (departments, department_id) => {
         const sectionFound = departments.find(
            (dept) => dept.i_num === department_id
         );
         // console.log(department_id, sectionFound);
         return sectionFound ? sectionFound.i_num : -1;
      };

      const handleClickUserEdit = (event, text, section_id, department_id) => {
         const { name } = event.currentTarget;
         const i_num = Number(name);
       
         this.setState(prevState => {
           const updatedData = prevState.detailData.map(item => ({
             ...item,
             i_num: item.i_num === i_num ? i_num : item.i_num
           }));
         //   const filteredData = updatedData.filter(item => item.i_num !== -1 && !item.isNew);
           return {
             detailData: updatedData,
             i_num: i_num,
             inputName: text,
             selectedSectionId: section_id,
             selectedDeptId: department_id,
             isNewItemVisible: false,
             isCanceled: false
           };
         },
         () => {
             //フォーカス設定
             if (this.nameInputRef.current) {
                 this.nameInputRef.current.focus();
             }
         });
       };
       
      // 課マスタ編集モードに変更
      const handleClickDeptEdit = (event, text) => {
         const { name } = event.currentTarget;
         const i_num = Number(name);

         this.setState(prevState => {
            const updatedData = prevState.detailData.map(item => ({
              ...item,
              i_num: item.i_num === i_num ? i_num : item.i_num
            }));
            // const filteredData = updatedData.filter(item => item.i_num !== -1 && !item.isNew);
            return {
              detailData: updatedData,
              i_num: i_num,
              inputName: text,
              isNewItemVisible: false,
              isCanceled: false
            };
          },
         () => {
             //フォーカス設定
             if (this.nameInputRef.current) {
                 this.nameInputRef.current.focus();
             }
         });
         this.setState({ i_num: Number(name) });
         this.setState({ inputName: text });
      };

      const handleClickOpenConfirmDialog = (event) => {
         const { value } = event.currentTarget;
         const selectedData = JSON.parse(value);

         swal({
            title: "削除確認",
            text: `「${selectedData.name}」を削除してもよろしいですか？`,
            icon: "warning",
            buttons: ["いいえ", "はい"],
            dangerMode: true,
         })
         .then((confirm) => {
            if (confirm) {
               handleClickDelete(selectedData);
            }
         });
      };

      const handleCloseConfirmDialog = () => {
         this.setState({ selectedData: {}, confirmDialog: false });
      };

      const handleClickDelete = async (selectedData) => {
         const i_num = Number(selectedData.i_num);

         const data = {
            process_type: "deleteMaster",
            table_name: kTables[this.state.tabValue],
            i_num: i_num,
         };

         try {
            const json = await postApi(data);
            if (json?.statusCode === 200) {
               const detailData = this.state.detailData.filter(
                  (row) => row.i_num !== i_num
               );
               this.setState({ detailData });
               swal({
                  title: "削除しました。",
                  icon: "success",
                  button: "はい"
               });
            } else {
               swal({
                  title: "設定エラー！",
                  text: "削除に失敗しました。",
                  icon: "warning",
                  button: "はい"
               });
            }

         } catch (error) {
            console.error("Error:", error);
            swal({
               title: "エラー！",
               text: "通信エラーが発生しました。",
               icon: "error",
               button: "はい"
            });
         };
      };

      const keyDown = (e) => {
         if (e.key === "Enter") {
         }
      };

      const createSortHandler = (property) => (event) => {
         const isAsc = this.state.orderBy === property && this.state.order === 'asc';
         // const order = {order: isAsc ? 'desc' : 'asc'};
         const order = isAsc ? "desc" : "asc";
         // this.setState(order);
         // const orderBy = {orderBy: property};
         const orderBy = property;
         let sortedData = stableSort(this.state.detailData, getComparator(order, orderBy));

         // this.setState({
         // ...order,
         // ...orderBy,
         // i_num: -1,
         // firstLoad: false,
         // });

         this.setState({
            order,
            orderBy,
            i_num: -1,
            firstLoad: false,
            detailData: sortedData
         });

         this.setState({detailData: sortedData});
         // localStorage.setItem('setting-user-sort', JSON.stringify({...order, ...orderBy}));
         localStorage.setItem('setting-user-sort', JSON.stringify({order, orderBy}));

      };
     
      const onDragStart = (start) => {
         this.setState({ isDnD: true });
      };

      const onDragEnd = (result) => {
         // 無効状態
         if (!this.state.isChangedPosition) {
            return;
         }

         // dropped outside the list
         if (!result.destination) {
            return;
         }

         const detailData = reorder(
            this.state.detailData,
            result.source.index,
            result.destination.index
         );
         this.setState({ detailData });
      };

      const handleEnableSort = () => {
         this.setState({ offset: 0, 
                         isChangedPosition: true,
                         name01: null,
                         name02: null,
                         name03: null,
                         name04: null,
                         department_name: null,
                         department_id: null,
                         section_name: null,
                         section_id: null});

         const params = {
            offset: "",
            limit: "",
            table_name: kTables[this.state.tabValue],
         };
         // this.getSettings(params);
      };

      const handleSavePosition = async () => {
         // this.savePositionSettings(this.state.detailData);
         const position = this.state.detailData.map((item, index) => ({
            [item.i_num]: index,
         }));

         const data = {
            process_type: "savePositionMaster",
            // table_name: "user_master",
            position,
         };

         try {
            const json = await postApi(data);
            this.setState({ isChangedPosition: false });
            const params = {
               table_name: kTables[this.state.tabValue],
            };
            this.getSettings(params);

         } catch (error) {
            console.error("Error:", error);

         };

      };

      const handleSavePositionCancel = () => {
         try {
            this.setState({ isChangedPosition: false });
            const params = {
               table_name: kTables[this.state.tabValue],
            };
            this.getSettings(params);

         } catch (error) {
            console.error("Error:", error);

         };
      };

      const filteredItems = detailData
         // ? ((this.state.firstLoad && tabValue === 1)
         //    ? detailData
         //    : (this.state.isChangedPosition ? detailData : stableSort(detailData, getComparator(order, orderBy)))
         //    ).filter(item => {
            ? detailData.filter(item => {
            if (tabValue === 0) {
            return (
               (this.state.user_id === null || (this.state.user_id === item.user_id)) &&
               (this.state.name01 === null || (this.state.name01 === "") || (this.state.name01 !== "" && item.name.includes(this.state.name01) ))
            );

            } else if (tabValue === 1) {
            return (
               (this.state.user_id === null || (this.state.user_id === item.user_id)) &&
               (this.state.name02 === null || (this.state.name02 === "") || (this.state.name02 !== "" && item.name.includes(this.state.name02) )) &&
               (this.state.section_id === null || (this.state.section_id === item.section_id)) &&
               (this.state.section_name === null || (this.state.section_name === "" ) || (this.state.section_name !== "" && item.section_name.includes(this.state.section_name) )) &&
               (this.state.department_id === null || (this.state.department_id === item.department_id)) &&
               (this.state.department_name === null || (this.state.department_name === "") || (this.state.department_name !== "" && item.department_name.includes(this.state.department_name) ))
            );

            } else if (tabValue === 2) {
            return (
               (this.state.user_id === null || (this.state.user_id === item.user_id)) &&
               (this.state.name03 === null || (this.state.name03 === "") || (this.state.name03 !== "" && item.name.includes(this.state.name03) ))

            );

            } else if (tabValue === 3) {
            return (
               (this.state.user_id === null || (this.state.user_id === item.user_id)) &&
               (this.state.name04 === null || (this.state.name04 === "") || (this.state.name04 !== "" && item.name.includes(this.state.name04) ))

            );
            }
            return true; 
         })
      : [];


      let user_options , section_options , department_options;
      if (filteredItems.length > 0) {
         user_options=getFilterOptions(filteredItems,["user_id","name"],"name","name")
                  .sort((a, b) => (a.name ?? "").localeCompare(b.name ?? "", undefined, {sensitivity: "base", numeric: true}));

         section_options=getFilterOptions(filteredItems,["section_id","section_name"],"section_name","section_name")
                  .sort((a, b) => (a.section_name ?? "").localeCompare(b.section_name ?? "", undefined, {sensitivity: "base", numeric: true}));

         department_options=getFilterOptions(filteredItems,["department_id","department_name"],"department_name","department_name")
                  .sort((a, b) => (a.department_name ?? "").localeCompare(b.department_name ?? "", undefined, {sensitivity: "base", numeric: true}));

      }

      const displayedItems = filteredItems.slice(offset * limit, offset * limit + limit);

      const handleChangeFilter = (filterDict) => {
         const { changeFilterDatas } = this.props
         this.setState({ ...this.state,firstLoad: false,...filterDict});
         changeFilterDatas({...filterDict});
      };

      return (
         <div className="content-container">
            <BreadCrumbNav screenName="マスタ編集"></BreadCrumbNav>
            <div className="setting-loginname">ログイン名：{user.username}</div>
            <Paper className="setting-container">
               <Tabs value={this.state.tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary" centered>
                  <Tab label="OSマスタ編集" />
                  <Tab label="ユーザーマスタ編集" />
                  <Tab label="部マスタ編集" />
                  <Tab label="課マスタ編集" />
               </Tabs>
            
               {isFetching ? (
                  <div className="loading">お待ちください．．．</div>
               ) : (
                  <div className="panel-container-setting" role="tabpanel"
                     hidden={this.state.tabValue !== OS_INDEX} id={`scrollable-auto-tabpanel-${OS_INDEX}`}
                     aria-labelledby={`scrollable-auto-tab-${OS_INDEX}`}
                  >
                     {this.state.tabValue === 0 && (
                        <>
                           <Button variant="contained" color="secondary"
                              className="button-new" name={kTables[0]} onClick={handleClickNew}
                              disabled={!kCanEditRole[user.role]}
                              style={{ marginRight: '10px'}}
                           >
                              新規登録
                           </Button>
                           <div className="filter-container">

                              <FormControl className="formterminal-filter">
                                 <Autocomplete
                                    freeSolo
                                    id="combo-box-autocomplete-user_name"
                                    className="combo-box-autocomplete-setting"
                                    value={this.state.name01}
                                    onChange={(event, newValue) => {
                                       // handleChangeFilter({user_id:newValue&&newValue.user_id?newValue.user_id:null,name01: newValue&&newValue.name?newValue.name:null, firstLoad: false , offset: 0});
                                       if (!newValue) {
                                          handleChangeFilter({
                                            user_id: null,
                                            name01: null,
                                            firstLoad: false,
                                            offset: 0
                                          });
                                       } else {
                                          handleChangeFilter({
                                            user_id: newValue.user_id??null,
                                            name01: newValue.name??null,
                                            firstLoad: false,
                                            offset: 0
                                          });
                                       }
                                    }}
                                    onInputChange={(event, value) => {
                                       if (event && event.type === "change") {
                                       handleChangeFilter({name01:value,user_id:null,firstLoad: false , offset: 0 });
                                       }
                                    }}
                                    options={
                                       this.state.name01 && this.state.name01.trim() !== "" && user_options
                                       ? user_options.filter(item => item.name.toLowerCase().includes(this.state.name01.toLowerCase()))
                                       : user_options || []
                                    }
                                    getOptionLabel={(option) => 
                                       typeof option === 'string' ? option : option?.name || ''
                                    }
                                    renderInput={(params) => (
                                       <TextField
                                          {...params}
                                          className="autocomplete-filter"
                                          label="OS ："
                                          variant="outlined"
                                          fullWidth
                                       />
                                    )}
                                 />
                              </FormControl>

                              <FormControl className="settingtab1-download">
                                 <Button variant="contained" color="primary" className="download-button"
                                    onClick={()=>this.handleClickDownloadCSV(filteredItems)}
                                 >
                                    ダウンロード
                                 </Button>
                              </FormControl>

                              <div className='setting-item-count'>
                                 <b> 検索結果：{filteredItems.filter(item => !item.isNew).length}件 </b>
                              </div>

                           </div>   
                           
                           <Paper>
                              <TableContainer className={ isShowPagination ? "setting-table-pagination-container": "setting-table-container" }>
                                 <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                       <TableRow>
                                          <TableCell key="name" align="center" 
                                             sortDirection={this.state.orderBy === "name" ? this.state.order : false} style={{ minWidth: 100 }}
                                          >              
                                             <TableSortLabel direction={this.state.orderBy === "name" ? this.state.order : 'asc'} onClick={createSortHandler("name")}> 
                                                OS {this.state.orderBy === "name" ? (
                                                   <span className="visuallyHidden">
                                                      {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                   </span>
                                                ) : null}
                                             </TableSortLabel>  
                                          </TableCell>

                                          <TableCell colSpan={2} align="center" style={{ maxWidth: 100 }} >
                                             操作
                                          </TableCell>
                                       </TableRow>
                                    </TableHead>

                                    <TableBody>
                                       {displayedItems.filter(item => {
                                          if (this.state.i_num !== -1 && item.isNew) return false;
                                             return true;
                                          }).map((item, index) => (
                                             <TableRow key={item.i_num}>
                                                <TableCell align="left" component="th" scope="row" >
                                                   {this.state.isCanceled !== true && (item.i_num === -1 || this.state.i_num === item.i_num) ? (
                                                      <TextField autoFocus
                                                         inputRef={this.nameInputRef}    //新規作成又は編集モードにはテキストボックスにフォーカスできるように
                                                         style={{ width: "100%",}}
                                                         name={item.i_num.toString()}
                                                         value={ this.state.inputName}
                                                         onChange={(e) => this.setState({ inputName:e.target.value,})} 
                                                         onKeyDown={keyDown}
                                                         onBlur={(e) => {
                                                            // フォーカスが外れた時の処理
                                                            // console.log(e.target.value);
                                                            // this.setState({ i_num: -1 });
                                                         }}
                                                         // key={Date.now()} 
                                                      />
                                                   ) : (
                                                      item.name
                                                   )}
                                                </TableCell>
                                                {(this.state.isCanceled === true || (item.i_num !== -1 && this.state.i_num !== item.i_num)) && (
                                                   <TableCell align="center" style={{ width: 100,}}>
                                                      <Button variant="outlined" color="primary" name={item.i_num}
                                                         onClick={(e) => handleClickEdit(e, item.name)}
                                                         disabled={!kCanEditRole[user.role]}
                                                      >
                                                         編集
                                                      </Button>
                                                   </TableCell>
                                                )}
                                                {(this.state.isCanceled === true || (item.i_num !== -1 && this.state.i_num !==item.i_num)) && (
                                                   <TableCell align="center" style={{ width: 100,}}>
                                                      <Button variant="outlined" color="primary"
                                                         name={item.i_num}
                                                         value={JSON.stringify({i_num: item.i_num,name: item.name,})}
                                                         onClick={handleClickOpenConfirmDialog} disabled={!kCanEditRole[user.role]}
                                                      >
                                                         削除
                                                      </Button>
                                                   </TableCell>
                                                )}
                                                {(this.state.isCanceled === false && (item.i_num === -1 || this.state.i_num ===item.i_num)) && (
                                                   <TableCell align="center" style={{ width: 100 }}>
                                                      <Button variant="outlined" color="primary" name={item.i_num} onClick={ handleClickAdd}
                                                         disabled={ !kCanEditRole[user.role]}
                                                      >
                                                         登録
                                                      </Button>
                                                   </TableCell>
                                                )}
                                                {(this.state.isCanceled === false && (item.i_num === -1 || this.state.i_num ===item.i_num)) && (
                                                   <TableCell align="center" style={{ width: 100 }}>
                                                      <Button variant="outlined" color="primary" name={item.i_num} onClick={(e) => handleClickCancel(e, item.name)}
                                                         disabled={ !kCanEditRole[user.role]}
                                                      >
                                                         戻る
                                                      </Button>
                                                   </TableCell>
                                                )}
                                             </TableRow>
                                          )
                                       )}
                                    </TableBody>
                                 </Table>
                              </TableContainer>
                              {filteredItems.length > 0 && 
                                 <div className='pagination-button'>
                                    <Pagination page={this.state.offset + 1} count={Math.ceil(filteredItems.length / this.state.limit)}
                                       onChange={this.changePagination} color="primary" variant="outlined"
                                       shape="rounded" showFirstButton
                                       showLastButton
                                    />
                                 </div>
                              }
                           </Paper>
                        </>
                     )}
                  </div>
               )}

               {isFetching ? (
                  <div className="loading">お待ちください．．．</div>
               ) : (
                  <div className="panel-container-setting" role="tabpanel"
                     hidden={this.state.tabValue !== USER_INDEX}
                     id={`scrollable-auto-tabpanel-${USER_INDEX}`}
                     aria-labelledby={`scrollable-auto-tab-${USER_INDEX}`}
                  >
                     {this.state.tabValue === USER_INDEX && (
                        <>
                           <div className="user-action-container">
                              <FormControl className="usersetting-button">
                                 <Button variant="contained" color="secondary"
                                    className="button-new" name={kTables[0]}
                                    onClick={handleClickNew}
                                    disabled={!kCanEditRole[user.role]}
                                 >
                                    新規登録
                                 </Button>

                              </FormControl>
                              

                              {this.state.isChangedPosition ? (
                                 <FormControl className="usersetting-position-button">
                                    <Button variant="contained" color="secondary"
                                       className="button-save" name={kTables[0]}
                                       onClick={handleSavePosition} disabled={!kCanSortRole[user.role]}
                                    >
                                       登録
                                    </Button>
                                    <Button variant="contained" color="gray"
                                       className="button-exit" name={kTables[0]}
                                       onClick={handleSavePositionCancel} disabled={!kCanSortRole[user.role]}
                                    >
                                       戻る
                                    </Button>
                                 </FormControl>
                              ) : (
                                 <Button variant="contained" color="primary" className="button-setting"
                                    name={kTables[0]} onClick={handleEnableSort}
                                    disabled={!kCanSortRole[user.role]}
                                 >
                                    位置切替
                                 </Button>
                              )}
                           </div>

                           <div className="filter-container">

                              <FormControl className="formterminal-filter">
                                 <Autocomplete
                                    freeSolo
                                    id="combo-box-autocomplete-user_name"
                                    className="combo-box-autocomplete-settinguser"
                                    disabled = {this.state.isChangedPosition}
                                    value={this.state.name02}
                                    onChange={(event, newValue) => {
                                       // handleChangeFilter({user_id:newValue&&newValue.user_id?newValue.user_id:null,name02: newValue&&newValue.name?newValue.name:null, firstLoad: false , offset: 0});
                                       if (!newValue) {
                                          handleChangeFilter({
                                            user_id: null,
                                            name02: null,
                                            firstLoad: false,
                                            offset: 0
                                          });
                                       } else {
                                          handleChangeFilter({
                                            user_id: newValue.user_id??null,
                                            name02: newValue.name??null,
                                            firstLoad: false,
                                            offset: 0
                                          });
                                       }
                                    }}
                                    
                                    onInputChange={(event, value) => {
                                       if (event && event.type === "change") {
                                       handleChangeFilter({name02:value,user_id:null,firstLoad: false , offset: 0 });
                                       }
                                    }}
                                    options={
                                       this.state.name02 && this.state.name02.trim() !== "" && user_options
                                       ? user_options.filter(item => item.name.toLowerCase().includes(this.state.name02.toLowerCase()))
                                       : user_options || []
                                    }
                                    getOptionLabel={(option) => 
                                       typeof option === 'string' ? option : option?.name || ''
                                    }
                                    renderInput={(params) => (
                                       <TextField
                                          {...params}
                                          className="autocomplete-filter"
                                          label="ユーザー名："
                                          variant="outlined"
                                          fullWidth
                                       />
                                    )}
                                 />
                              </FormControl>

                              <FormControl className="formterminal-filter">
                                 <Autocomplete
                                    freeSolo
                                    id="combo-box-autocomplete-section_name"
                                    className="combo-box-autocomplete-settinguser"
                                    disabled = {this.state.isChangedPosition}
                                    value={this.state.section_name}
                                    onChange={(event, newValue) => {
                                       // handleChangeFilter({section_id:newValue&&newValue.section_id?newValue.section_id:null,section_name: newValue&&newValue.section_name?newValue.section_name:null,firstLoad: false , offset: 0});
                                       if (!newValue) {
                                          handleChangeFilter({
                                            section_id: null,
                                            section_name: null,
                                            firstLoad: false,
                                            offset: 0
                                          });
                                       } else {
                                          handleChangeFilter({
                                            section_id: newValue.section_id??null,
                                            section_name: newValue.section_name??null,
                                            firstLoad: false,
                                            offset: 0
                                          });
                                       }
                                    }}
                                    
                                    onInputChange={(event, value) => {
                                       if (event && event.type === "change") {
                                       handleChangeFilter({section_name:value,section_id:null,firstLoad: false , offset: 0});
                                       }
                                    }}
                                    options={
                                       this.state.section_name && this.state.section_name.trim() !== "" && section_options
                                       ? section_options.filter(item => item.section_name.toLowerCase().includes(this.state.section_name.toLowerCase()))
                                       : section_options || []
                                    }
                                    getOptionLabel={(option) => 
                                       typeof option === 'string' ? option : option?.section_name || ''
                                    }
                                    renderInput={(params) => (
                                       <TextField
                                          {...params}
                                          className="autocomplete-filter"
                                          label="部："
                                          variant="outlined"
                                          fullWidth
                                       />
                                    )}
                                 />
                              </FormControl>

                              <FormControl className="formterminal-filter">
                                 <Autocomplete
                                    freeSolo
                                    id="combo-box-autocomplete-department_name"
                                    className="combo-box-autocomplete-settinguser"
                                    disabled = {this.state.isChangedPosition}
                                    value={this.state.department_name}
                                    onChange={(event, newValue) => {
                                       // handleChangeFilter({department_id:newValue&&newValue.department_id?newValue.department_id:null,department_name: newValue&&newValue.department_name?newValue.department_name:null, firstLoad: false , offset: 0});
                                       if (!newValue) {
                                          handleChangeFilter({
                                            department_id: null,
                                            department_name: null,
                                            firstLoad: false,
                                            offset: 0
                                          });
                                       } else {
                                          handleChangeFilter({
                                            department_id: newValue.department_id ?? null,
                                            department_name: newValue.department_name??null,
                                            firstLoad: false,
                                            offset: 0
                                          });
                                       }
                                    }}
                                    
                                    onInputChange={(event, value) => {
                                       if (event && event.type === "change") {
                                          handleChangeFilter({department_name:value,department_id:null,firstLoad: false , offset: 0 });
                                       }
                                    }}

                                    options={
                                       this.state.department_name && this.state.department_name.trim() !== "" && department_options
                                          ? department_options.filter(item => item.department_name.toLowerCase().includes(this.state.department_name.toLowerCase()))
                                          : department_options || []
                                    }

                                    getOptionLabel={(option) => 
                                       typeof option === 'string' ? option : option?.department_name || ''
                                    }
                                    renderInput={(params) => (
                                       <TextField
                                          {...params}
                                          className="autocomplete-filter"
                                          label="課："
                                          variant="outlined"
                                          fullWidth
                                       />
                                    )}
                                 />
                              </FormControl>

                              <FormControl className="formpcspec-filter">
                                 <Button variant="contained" color="primary" className="download-button-setting"
                                    onClick={()=>this.handleClickDownloadCSV(filteredItems)}
                                 >
                                    ダウンロード
                                 </Button>
                              </FormControl>

                              <div className='setting-item-count'>
                                 <b> 検索結果：{filteredItems.filter(item => !item.isNew).length}件 </b>
                              </div>

                           </div>

                           <Paper>
                              <TableContainer
                                 className={ isShowPagination
                                       ? "setting-table-pagination-container"
                                       : "setting-table-container"
                                 }
                              >
                                 <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
                                    <Table stickyHeader aria-label="sticky table">
                                       <TableHead>
                                          <TableRow>
                                             {headCells.map((headCell) => (
                                                <TableCell key={headCell.id} align="center" 
                                                   sortDirection={this.state.orderBy === headCell.id ? this.state.order : false}
                                                   style={{ minWidth: headCell.minWidth }}
                                                >              
                                                   <TableSortLabel
                                                      direction={this.state.orderBy === headCell.id ? this.state.order : 'asc'}
                                                      onClick={createSortHandler(headCell.id)}
                                                   >
                                                      {headCell.label}
                                                      {this.state.orderBy === headCell.id ? (
                                                         <span className="visuallyHidden">
                                                            {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                         </span>
                                                            ) : null}
                                                   </TableSortLabel>  
                                                </TableCell>
                                             ))}
                                             <TableCell colSpan={2} align="center" style={{ maxWidth: 100 }}> 操作</TableCell>
                                          </TableRow>
                                       </TableHead>
                                       <Droppable droppableId="droppable"
                                          isDropDisabled={!this.state.isChangedPosition }
                                       >
                                          {(provided, snapshot) => (
                                             <TableBody {...provided.droppableProps} ref={provided.innerRef}
                                                style={getListStyle(snapshot.isDraggingOver)}
                                             >
                                                {displayedItems.filter(item => {
                                                   if (this.state.i_num !== -1 && item.isNew) return false;
                                                      return true;
                                                   }).map((item, index) => (
                                                         <Draggable key={item.i_num.toString()}
                                                            draggableId={item.i_num.toString()}
                                                            index={index} isDragDisabled={!this.state.isChangedPosition}
                                                         >
                                                            {( provided,snapshot) => (
                                                               <TableRow ref={ provided.innerRef}
                                                                  {...provided.draggableProps}
                                                                  {...provided.dragHandleProps}
                                                                  style={getItemStyle( snapshot.isDragging,provided.draggableProps.style,
                                                                     !this.state.isChangedPosition
                                                                  )}
                                                               >
                                                                  <TableCell align="left" component="th" scope="row">
                                                                     {this.state.isCanceled !== true && (item.i_num ===-1 || this.state.i_num === item.i_num) ? (
                                                                        <TextField autoFocus
                                                                           inputRef={this.nameInputRef} //新規作成又は編集モードにはテキストボックスにフォーカスできるように
                                                                           style={{ width: "100%",}} name={item.i_num.toString()}
                                                                           value={ this.state.inputName}
                                                                           onChange={(e) => this.setState({inputName:e.target.value,})}
                                                                           onKeyDown={keyDown}
                                                                           onBlur={(
                                                                              e
                                                                           ) => {
                                                                              // フォーカスが外れた時の処理
                                                                              // console.log(e.target.value);
                                                                              // this.setState({ i_num: -1 });
                                                                           }}
                                                                           // key={Date.now()} 
                                                                        />
                                                                     ) : (
                                                                        item.name
                                                                     )}
                                                                  </TableCell>

                                                                  <TableCell align="left">
                                                                     {this.state.isCanceled !== true && (item.i_num === -1 || this.state.i_num === item.i_num) ? (
                                                                        <FormControl variant="outlined" className="cell-department">
                                                                           <Select name={item.section_id.toString()}
                                                                              value={this.state.selectedSectionId}
                                                                              onChange={(e) =>
                                                                                 this.setState({selectedSectionId:getSelectedSectionId(this.state.sections,e.target.value),})
                                                                              }
                                                                           >
                                                                              <MenuItem value={-1}></MenuItem>
                                                                              {(this.state.sections ||[]).map(
                                                                                 (section) => (
                                                                                    <MenuItem key={section.i_num} value={section.i_num}>
                                                                                       {section.name}
                                                                                    </MenuItem>
                                                                                 )
                                                                              )}
                                                                           </Select>
                                                                        </FormControl>
                                                                     ) : (
                                                                        item.section_name
                                                                     )}
                                                                  </TableCell>

                                                                  <TableCell align="left">
                                                                     {this.state.isCanceled !== true && (item.i_num ===-1 ||this.state.i_num === item.i_num) ? (
                                                                        <FormControl variant="outlined" className="cell-department">
                                                                           <Select name={item.department_id.toString()} value={this.state.selectedDeptId}
                                                                              onChange={(e) =>
                                                                                 this.setState(
                                                                                    {selectedDeptId:getSelectedDeptId(this.state.departments,e.target.value),}
                                                                                 )
                                                                              }
                                                                           >
                                                                              <MenuItem value={-1}></MenuItem>
                                                                              {(this.state.departments ||[]).map(
                                                                                 (department,index) => (
                                                                                    <MenuItem key={index} value={department.i_num}> {department.name}</MenuItem>
                                                                                 )
                                                                              )}
                                                                           </Select>
                                                                        </FormControl>
                                                                     ) : (
                                                                        item.department_name
                                                                     )}
                                                                  </TableCell>
                                                                  {(this.state.isCanceled === true || (item.i_num !==-1 &&this.state.i_num !==item.i_num)) && (
                                                                     <TableCell align="center" style={{ width: 100,}}>
                                                                        <Button variant="outlined"color="primary" name={item.i_num}
                                                                           onClick={(e) => handleClickUserEdit(e,item.name,item.section_id,item.department_id )}
                                                                           disabled={!kCanEditRole[user.role]}
                                                                        >
                                                                           編集
                                                                        </Button>
                                                                     </TableCell>
                                                                  )}

                                                                  {(this.state.isCanceled === true || (item.i_num !==-1 &&this.state.i_num !==item.i_num)) && (
                                                                     <TableCell align="center"style={{width: 100,}}>
                                                                        <Button variant="outlined" color="primary"
                                                                           name={item.i_num}
                                                                           value={JSON.stringify({i_num: item.i_num,name: item.name,})}
                                                                           onClick={handleClickOpenConfirmDialog}
                                                                           disabled={!kCanEditRole[user.role]}
                                                                        >
                                                                           削除
                                                                        </Button>
                                                                     </TableCell>
                                                                  )}

                                                                  {(this.state.isCanceled === false && (item.i_num ===-1 ||
                                                                     this.state.i_num ===item.i_num)) && (
                                                                     <TableCell align="center" style={{width: 100,}}>
                                                                        <Button variant="outlined" color="primary"
                                                                           name={item.i_num} onClick={ handleClickAdd} disabled={!kCanEditRole[ user.role]}
                                                                        >
                                                                           登録
                                                                        </Button>
                                                                     </TableCell>
                                                                  )}

                                                                  {(this.state.isCanceled === false && (item.i_num ===-1 ||
                                                                     this.state.i_num ===item.i_num)) && (
                                                                     <TableCell align="center" style={{width: 100,}}>
                                                                        <Button variant="outlined" color="primary"
                                                                           name={item.i_num} onClick={ (e) => handleClickCancel(e, item.name)} disabled={!kCanEditRole[ user.role]}
                                                                        >
                                                                           戻る
                                                                        </Button>
                                                                     </TableCell>
                                                                  )}
                                                               </TableRow>
                                                            )}
                                                         </Draggable>
                                                      )
                                                   )}
                                                {provided.placeholder}
                                             </TableBody>
                                          )}
                                       </Droppable>
                                    </Table>
                                 </DragDropContext>
                              </TableContainer>
                              {filteredItems.length > 0 && 
                                 <div className='pagination-button'>
                                    <Pagination
                                       page={this.state.offset + 1}
                                       count={Math.ceil(filteredItems.length / this.state.limit)}
                                       onChange={this.changePagination} color="primary" variant="outlined"
                                       shape="rounded"
                                       showFirstButton
                                       showLastButton
                                    />
                                 </div>
                              }
                           </Paper>
                        </>
                     )}
                  </div>
               )}

               {isFetching ? (
                  <div className="loading">お待ちください．．．</div>
               ) : (
                  <div className="panel-container-setting" role="tabpanel"
                     hidden={this.state.tabValue !== SECTION_INDEX}
                     id={`scrollable-auto-tabpanel-${SECTION_INDEX}`}
                     aria-labelledby={`scrollable-auto-tab-${SECTION_INDEX}`}
                  >
                     {this.state.tabValue === SECTION_INDEX && (
                        <>
                           <Button variant="contained" color="secondary"
                              className="button-new" name={kTables[0]}
                              onClick={handleClickNew}
                              disabled={!kCanEditRole[user.role]}
                           >
                              新規登録
                           </Button>
                           <div className="filter-container">
                              <FormControl className="formterminal-filter">
                                 <Autocomplete
                                    freeSolo
                                    id="combo-box-autocomplete-user_name"
                                    className="combo-box-autocomplete-setting"
                                    value={this.state.name03}
                                    onChange={(event, newValue) => {
                                       handleChangeFilter({
                                          user_id:newValue&&newValue.user_id?newValue.user_id:null,
                                          name03: newValue&&newValue.name?newValue.name:null, 
                                          firstLoad: false , 
                                          offset: 0});
                                    }}
                                    // onChange={(event, newValue) => {
                                    //    if (!newValue) {
                                    //    handleChangeFilter({
                                    //       name03: null,
                                    //       user_id: null,
                                    //       firstLoad: false,
                                    //       offset: 0
                                    //    });
                                    //    } else {
                                    //    handleChangeFilter({
                                    //       user_id: newValue.user_id ?? null,
                                    //       name03: newValue.name03 ?? "",
                                    //       firstLoad: false,
                                    //       offset: 0
                                    //    });
                                    //    }
                                    // }}
                                    onInputChange={(event, value) => {
                                       if (event && event.type === "change") {
                                       handleChangeFilter({name03:value,user_id:null,firstLoad: false , offset: 0 });
                                       }
                                    }}
                                    options={
                                       this.state.name03 && this.state.name03.trim() !== "" && user_options
                                       ? user_options.filter(item => item.name.toLowerCase().includes(this.state.name03.toLowerCase()))
                                       : user_options || []
                                    }
                                    getOptionLabel={(option) => 
                                       typeof option === 'string' ? option : option?.name || ''
                                    }
                                    renderInput={(params) => (
                                       <TextField
                                          {...params}
                                          className="autocomplete-filter"
                                          label="部："
                                          variant="outlined"
                                          fullWidth
                                       />
                                    )}
                                 />
                              </FormControl>

                              <FormControl className="settingtab3-download">
                                 <Button variant="contained" color="primary"
                                    className="download-button"
                                    onClick={()=>this.handleClickDownloadCSV(filteredItems)}
                                    // disabled={!this.props.items || this.props.items.length === 0}
                                 >
                                    ダウンロード
                                 </Button>
                              </FormControl>

                              <div className='setting-item-count'>
                                 <b> 検索結果：{filteredItems.filter(item => !item.isNew).length}件 </b>
                              </div>
                              
                           </div>

                           {isFetching ? (
                              <div className="loading">お待ちください．．．</div>
                           ) : (
                              <Paper>
                                 <TableContainer
                                    className={
                                       isShowPagination
                                          ? "setting-table-pagination-container"
                                          : "setting-table-container"
                                    }
                                 >
                                    <Table stickyHeader aria-label="sticky table">
                                       <TableHead>
                                          <TableRow>
                                             <TableCell key="name" align="center" sortDirection={this.state.orderBy === "name" ? this.state.order : false} style={{ minWidth: 100 }}>              
                                                <TableSortLabel direction={this.state.orderBy === "name" ? this.state.order : 'asc'} onClick={createSortHandler("name")}>
                                                   部
                                                   {this.state.orderBy === "name" ? (
                                                      <span className="visuallyHidden">
                                                         {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                      </span>
                                                   ) : null}
                                                </TableSortLabel>  
                                             </TableCell>

                                             <TableCell colSpan={2} align="center" style={{ maxWidth: 100 }}> 操作 </TableCell>
                                          </TableRow>
                                       </TableHead>
                                       <TableBody>
                                          {displayedItems.filter(item => {
                                             if (this.state.i_num !== -1 && item.isNew) return false;
                                                return true;
                                             }).map((item, index) => (
                                                   <TableRow key={index}>
                                                      <TableCell align="left" component="th" scope="row">
                                                         {this.state.isCanceled !== true && (item.i_num === -1 || this.state.i_num === item.i_num) ? (
                                                            <TextField autoFocus
                                                               inputRef={this.nameInputRef} //新規作成又は編集モードにはテキストボックスにフォーカスできるように
                                                               style={{ width: "100%",}} name={item.i_num.toString()}
                                                               value={ this.state.inputName}
                                                               onChange={(e) => this.setState({inputName:e.target.value,})}
                                                               onKeyDown={keyDown}
                                                               onBlur={(e) => {
                                                                  // フォーカスが外れた時の処理
                                                                  // console.log(e.target.value);
                                                                  // this.setState({ i_num: -1 });
                                                               }}
                                                               // key={Date.now()} 
                                                            />
                                                         ) : (
                                                            item.name
                                                         )}
                                                      </TableCell>
                                                      {(this.state.isCanceled === true || (item.i_num !== -1 && this.state.i_num !== item.i_num)) && (
                                                         <TableCell align="center" style={{ width: 100,}}>
                                                            <Button variant="outlined" color="primary" name={item.i_num}
                                                               onClick={(e) => handleClickEdit(e,item.name)}
                                                               disabled={!kCanEditRole[user.role]}
                                                            >
                                                               編集
                                                            </Button>
                                                         </TableCell>
                                                      )}

                                                      {(this.state.isCanceled === true || (item.i_num !== -1 && this.state.i_num !== item.i_num)) && (
                                                         <TableCell align="center" style={{ width: 100,}}>
                                                            <Button variant="outlined" color="primary" name={item.i_num}
                                                               value={JSON.stringify({ i_num: item.i_num, name: item.name,})}
                                                               onClick={handleClickOpenConfirmDialog}
                                                               disabled={!kCanEditRole[user.role]}
                                                            >
                                                               削除
                                                            </Button>
                                                         </TableCell>
                                                      )}

                                                      {(this.state.isCanceled === false && (item.i_num === -1 || this.state.i_num === item.i_num)) && (
                                                         <TableCell align="center" style={{ width: 100 }}>
                                                            <Button variant="outlined" color="primary" name={item.i_num}
                                                               onClick={handleClickAddSection}
                                                               disabled={!kCanEditRole[user.role]
                                                               }
                                                            >
                                                               登録
                                                            </Button>
                                                         </TableCell> 
                                                      )}

                                                      {(this.state.isCanceled === false && (item.i_num === -1 || this.state.i_num === item.i_num)) && (
                                                         <TableCell align="center" style={{ width: 100 }}>
                                                            <Button variant="outlined" color="primary" name={item.i_num}
                                                               onClick={(e) => handleClickCancel(e, item.name)}
                                                               disabled={!kCanEditRole[user.role]
                                                               }
                                                            >
                                                               戻る
                                                            </Button>
                                                         </TableCell>
                                                      )}
                                                   </TableRow>
                                                )
                                             )}
                                       </TableBody>
                                    </Table>
                                 </TableContainer>
                                 {filteredItems.length > 0 && 
                                    <div className='pagination-button'>
                                       <Pagination
                                          page={this.state.offset + 1}
                                          count={Math.ceil(filteredItems.length / this.state.limit)}
                                          onChange={this.changePagination} color="primary" variant="outlined"
                                          shape="rounded"
                                          showFirstButton
                                          showLastButton
                                       />
                                    </div>
                                 }
                              </Paper>
                           )}
                        </>
                     )}
                  </div>
               )}

               {isFetching ? (
                  <div className="loading">お待ちください．．．</div>
               ) : (
                  <div className="panel-container-setting" role="tabpanel"
                     hidden={this.state.tabValue !== DEPT_INDEX}
                     id={`scrollable-auto-tabpanel-${DEPT_INDEX}`}
                     aria-labelledby={`scrollable-auto-tab-${DEPT_INDEX}`}
                  >
                     {this.state.tabValue === DEPT_INDEX && (
                        <>
                           <Button variant="contained" color="secondary"
                              className="button-new" name={kTables[0]}
                              onClick={handleClickNew}
                              disabled={!kCanEditRole[user.role]}
                           >
                              新規登録
                           </Button>
                           <div className="filter-container">
                              <FormControl className="formterminal-filter">
                                 <Autocomplete
                                    freeSolo
                                    id="combo-box-autocomplete-user_name"
                                    className="combo-box-autocomplete-setting"
                                    value={this.state.name04}
                                    onChange={(event, newValue) => {
                                       handleChangeFilter({
                                          user_id:newValue&&newValue.user_id?newValue.user_id:null,
                                          name04: newValue&&newValue.name?newValue.name:null, 
                                          firstLoad: false , 
                                          offset: 0
                                       });
                                    }}
                                    // onChange={(event, newValue) => {
                                    //    if (!newValue) {
                                    //    handleChangeFilter({
                                    //       name04: null,
                                    //       user_id: null,
                                    //       firstLoad: false,
                                    //       offset: 0
                                    //    });
                                    //    } else {
                                    //    handleChangeFilter({
                                    //       user_id: newValue.user_id ?? null,
                                    //       name04: newValue.name04 ?? "",
                                    //       firstLoad: false,
                                    //       offset: 0
                                    //    });
                                    //    }
                                    // }}
                                    onInputChange={(event, value) => {
                                       if (event && event.type === "change") {
                                       handleChangeFilter({name04:value,user_id:null,firstLoad: false , offset: 0 });
                                       }
                                    }}
                                    options={
                                       this.state.name04 && this.state.name04.trim() !== "" && user_options
                                       ? user_options.filter(item => item.name.toLowerCase().includes(this.state.name04.toLowerCase()))
                                       : user_options || []
                                    }
                                    getOptionLabel={(option) => 
                                       typeof option === 'string' ? option : option?.name || ''
                                    }
                                    renderInput={(params) => (
                                       <TextField
                                          {...params}
                                          className="autocomplete-filter"
                                          label="課："
                                          variant="outlined"
                                          fullWidth
                                       />
                                    )}
                                 />
                              </FormControl>

                              <FormControl className="terminal-download">
                                 <Button variant="contained" color="primary"
                                    className="download-button"
                                    onClick={()=>this.handleClickDownloadCSV(filteredItems)}
                                    // disabled={!this.props.items || this.props.items.length === 0}
                                 >
                                    ダウンロード
                                 </Button>
                              </FormControl>

                              <div className='setting-item-count'>
                                 <b> 検索結果：{filteredItems.filter(item => !item.isNew).length}件 </b>
                              </div>

                           </div>

                           {isFetching ? (
                              <div className="loading">お待ちください．．．</div>
                           ) : (
                              <Paper>
                                 <TableContainer
                                    className={
                                       isShowPagination
                                          ? "setting-table-pagination-container"
                                          : "setting-table-container"
                                    }
                                 >
                                    <Table stickyHeader aria-label="sticky table">
                                       <TableHead>
                                          <TableRow>
                                             <TableCell key="name" align="center" sortDirection={this.state.orderBy === "name" ? this.state.order : false} style={{ minWidth: 100 }}>              
                                                <TableSortLabel direction={this.state.orderBy === "name" ? this.state.order : 'asc'} onClick={createSortHandler("name")}>
                                                   課
                                                   {this.state.orderBy === "name" ? (
                                                      <span className="visuallyHidden">
                                                         {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                      </span>
                                                   ) : null}
                                                </TableSortLabel>  
                                             </TableCell>

                                             <TableCell colSpan={2} align="center" style={{ maxWidth: 100 }}>
                                                操作
                                             </TableCell>
                                          </TableRow>
                                       </TableHead>

                                       <TableBody>
                                          {displayedItems.filter(item => {
                                             if (this.state.i_num !== -1 && item.isNew) return false;
                                                return true;
                                             }).map((item, index) => (
                                                <TableRow key={index}>
                                                   <TableCell align="left" component="th" scope="row">
                                                      {this.state.isCanceled !== true && (item.i_num === -1 || this.state.i_num === item.i_num) ? (
                                                         <TextField autoFocus
                                                            inputRef={this.nameInputRef} //新規作成又は編集モードにはテキストボックスにフォーカスできるように
                                                            style={{ width: "100%",}}
                                                            name={item.i_num.toString()} value={ this.state.inputName}
                                                            onChange={(e) => this.setState({ inputName:e.target.value,})}
                                                            onKeyDown={keyDown}
                                                            onBlur={(e) => {
                                                               // フォーカスが外れた時の処理
                                                               // console.log(e.target.value);
                                                               // this.setState({ i_num: -1 });
                                                            }}
                                                            // key={Date.now()} 
                                                         />
                                                      ) : (
                                                         item.name
                                                      )}
                                                   </TableCell>

                                                   {(this.state.isCanceled === true || (item.i_num !== -1 && this.state.i_num !== item.i_num)) && (
                                                      <TableCell align="center" style={{ width: 100, }}>
                                                         <Button variant="outlined" color="primary" name={item.i_num}
                                                            onClick={(e) => handleClickDeptEdit( e,item.name)}
                                                            disabled={!kCanEditRole[user.role]}
                                                         >
                                                            編集
                                                         </Button>
                                                      </TableCell>
                                                   )}

                                                   {(this.state.isCanceled === true || (item.i_num !== -1 && this.state.i_num !== item.i_num)) && (
                                                      <TableCell align="center" style={{ width: 100,}}>
                                                         <Button variant="outlined" color="primary" name={item.i_num}
                                                            value={JSON.stringify({ i_num: item.i_num, name: item.name,})}
                                                            onClick={handleClickOpenConfirmDialog}
                                                            disabled={!kCanEditRole[user.role]}
                                                         >
                                                            削除
                                                         </Button>
                                                      </TableCell>
                                                   )}

                                                   {(this.state.isCanceled === false && (item.i_num === -1 || this.state.i_num === item.i_num)) && (
                                                      <TableCell align="center" style={{ width: 100 }}>
                                                         <Button variant="outlined" color="primary" name={item.i_num}
                                                            onClick={ handleClickAddDept}
                                                            disabled={!kCanEditRole[user.role]}
                                                         >
                                                            登録
                                                         </Button>
                                                      </TableCell>
                                                   )}

                                                   {(this.state.isCanceled === false && (item.i_num === -1 || this.state.i_num === item.i_num)) && (
                                                      <TableCell align="center" style={{ width: 100 }}>
                                                         <Button variant="outlined" color="primary" name={item.i_num}
                                                            onClick={ (e) => handleClickCancel(e, item.name)}
                                                            disabled={!kCanEditRole[user.role]}
                                                         >
                                                            戻る
                                                         </Button>
                                                      </TableCell>
                                                   )}
                                                </TableRow>
                                             )
                                             )}
                                       </TableBody>
                                    </Table>
                                 </TableContainer>
                                 {filteredItems.length > 0 && 
                                    <div className='pagination-button'>
                                       <Pagination
                                          page={this.state.offset + 1}
                                          count={Math.ceil(filteredItems.length / this.state.limit)}
                                          onChange={this.changePagination} color="primary" variant="outlined"
                                          shape="rounded"
                                          showFirstButton
                                          showLastButton
                                       />
                                    </div>
                                 }
                              </Paper>
                           )}
                        </>
                     )}
                  </div>
               )}
               
            </Paper>

            <Dialog
               open={this.state.confirmDialog}
               onClose={handleCloseConfirmDialog}
               aria-labelledby="alert-dialog-title"
               aria-describedby="alert-dialog-description"
            >
               <DialogTitle id="alert-dialog-title">{"削除確認"}</DialogTitle>
               <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                     {`「${this.state.selectedData.name}」を削除してもよろしいですか？`}
                  </DialogContentText>
               </DialogContent>
               <DialogActions>
                  <Button onClick={handleClickDelete} color="primary">
                     はい
                  </Button>
                  <Button onClick={handleCloseConfirmDialog} color="primary" autoFocus>
                     いいえ
                  </Button>
               </DialogActions>
            </Dialog>
         </div>
      );
   }
}

Setting.propTypes = {
   getSettings: PropTypes.func.isRequired,
   changeFilterDatas: PropTypes.func.isRequired,
};

export default Setting;
